import { FC, useCallback, useEffect, useState } from 'react';

import { MasterAgreement, Service } from '../../../store/_declarations/target';
import { montlyRateCalculationApi } from '../../../store/api/financialCalculator';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { checkVisibilityRule } from '../../../utils/parsers';
import OptionalServices from '../../molecules/OptionalServices';
import ServiceList from '../ServicesList';

type ServicesProps = {
  item: MasterAgreement;
};

const Services: FC<ServicesProps> = ({ item }) => {
  const { consumerPayload, visibilityFeatures } = useAppSelector(
    (state) => state.app
  );
  const { listByVehicle, montlyRateCalculationPayloads } = useAppSelector(
    (state) => state.financialCalculator
  );

  const dispatch = useAppDispatch();

  const [itemDetails, setItemDetails] = useState<any>({
    servicesListMandatory: [],
    servicesListOptional: []
  });

  const servicesBase =
    montlyRateCalculationPayloads?.[item.masterAgreement]?.widgetSelection
      ?.parameters?.services ||
    item.services.filter(
      (s) =>
        s.isMandatory ||
        s.isMandatoryCategory ||
        s.zzRecomCategory ||
        !s.isVisible
    );

  useEffect(() => {
    if (item) {
      const serviceList = (item.services || [])?.filter((e) => e.isVisible);

      setItemDetails({
        servicesListMandatory: serviceList.filter(
          (e) => e.isMandatory || e.isMandatoryCategory
        ),
        servicesListOptional: serviceList.filter(
          (e) => e.isOptional || e.isOptionalCategory
        )
      });
    }
  }, [item]);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleUpdateOptionalServices = (services: string[]) => {
    if (listByVehicle) {
      /* const notVisibleServices = item.services.filter((s) => !s.isVisible);
      const mandatoryS = item.services.filter(
        (s) => s.isMandatory || s.isMandatoryCategory
      );
      const optionalS = item.services.filter((s) =>
        services.includes(s.zzService)
      ); */
    }
  };

  const handleUpdateCategoryService = useCallback(
    (rootService: Service, optionService: Service) => {
      if (listByVehicle) {
        const category = item.services.find(
          (s) => s.zzService === rootService.zzService
        );
        const categoryChildren = (category?.otherServices || []).map(
          (o) => o.zzService
        );
        const newOption = category?.otherServices?.find(
          (s) => s.zzService === optionService.zzService
        );
        // remove parent category and eventual child
        const services = (servicesBase || []).filter(
          (s) =>
            s.zzService !== category?.zzService ||
            !categoryChildren.includes(s.zzService)
        );

        if (newOption) {
          services.push(newOption);
        }

        dispatch(
          montlyRateCalculationApi({
            masterAgreement: item.masterAgreement,
            pricingProcedure: item.pricingProcedure,
            widgetSelection: {
              parameters: { masterAgreement: item.masterAgreement, services },
              vehicle: {
                accessory: item.accessory
              }
            }
          })
        );
      }
    },
    [item, listByVehicle, consumerPayload]
  );

  return (
    <>
      {itemDetails.servicesListMandatory.length > 0 ? (
        <ServiceList
          onChangeCategory={handleUpdateCategoryService}
          servicesList={itemDetails.servicesListMandatory}
        />
      ) : null}
      {checkVisibilityRule('optionalServices', visibilityFeatures) &&
      itemDetails.servicesListOptional.length > 0 ? (
        <OptionalServices
          callbackOnSelection={handleUpdateOptionalServices}
          list={itemDetails.servicesListOptional}
        />
      ) : null}
    </>
  );
};

export default Services;
